import { Notice } from 'telia-front-react';
import * as React from 'react';

interface IAccentedWithAlert {
  showAlert?: boolean;
  children?: string;
}

export default class AccentedWithAlert extends React.Component<IAccentedWithAlert> {
  public render(): JSX.Element {
    return (
      <span className={this.props.showAlert ? 'text-error' : undefined}>
        {this.props.showAlert ? (
          <Notice className="text-error" type="error" size="small">
            {this.props.children}
          </Notice>
        ) : (
          this.props.children
        )}
      </span>
    );
  }
}
